const UPDATES = [
  { date: '2025-07-30', title: '暑期档热门大片专题上线', desc: '2025暑期档最受期待影片合集正式上线，涵盖动作、科幻、动画等多种类型，陪你度过精彩暑假。', tag: '专题' },
  { date: '2025-07-25', title: '4K超清专区全面升级', desc: '平台4K超清专区完成技术升级，新增200+部4K片源，画质更清晰，色彩更饱满，观影体验大幅提升。', tag: '技术' },
  { date: '2025-07-18', title: '移动端App 3.0版本发布', desc: 'iOS与Android双平台同步更新，优化播放引擎，新增智能推荐和离线缓存功能，随时随地畅享高清。', tag: '产品' },
  { date: '2025-07-10', title: '用户量突破5000万', desc: '感谢所有用户的支持与信任，51视频月活跃用户正式突破5000万大关，我们将继续努力提供更好的服务。', tag: '里程碑' },
  { date: '2025-07-02', title: '纪录片频道全新改版', desc: '纪录片频道页面全面改版，新增自然、人文、科技三大分类，精选全球高分纪录片一站式观看。', tag: '内容' },
  { date: '2025-06-25', title: 'CDN加速节点扩展至全球', desc: '新增东南亚、北美、欧洲等地区CDN节点，海外用户观看体验显著提升，延迟降低60%以上。', tag: '技术' },
  { date: '2025-06-15', title: '智能推荐算法2.0上线', desc: '基于深度学习的推荐系统升级，更精准地理解用户偏好，推荐命中率提升40%，发现更多好内容。', tag: '产品' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
          <p className="text-sm text-foreground-500 mt-2">关注51视频的最新变化与成长</p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300 hidden sm:block"></div>

          <div className="space-y-6">
            {UPDATES.map((item, idx) => (
              <div key={idx} className="flex gap-4 sm:gap-6">
                {/* Timeline dot */}
                <div className="hidden sm:flex flex-shrink-0 w-10 flex-col items-center">
                  <span className="w-3.5 h-3.5 rounded-full bg-primary-500 mt-1.5 flex-shrink-0"></span>
                </div>
                {/* Content */}
                <div className="flex-1 bg-background-50 border border-background-200/60 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-all">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-[10px] px-1.5 py-0.5 bg-primary-100 text-primary-700 rounded font-medium whitespace-nowrap">{item.tag}</span>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}